module.exports = __webpack_public_path__ + "static/media/nb2.1980b6c7.jpg";